import { useLocation } from 'react-router-dom';

const useURLSearchParams = (names: string[]): (string | null)[] => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return names.map((name) => params.get(name));
};

export default useURLSearchParams;
